<div class="col-md-12">
  <br>
    <div class="form-group has-search col-md-6">
      <fa-icon class="form-control-feedback" [icon]="faSearch"></fa-icon>
      <input type="text" name="search" [ngModel]="searchUser()" (ngModelChange)="searchUser.set($event)" class="form-control" placeholder="Search by username">
    </div>
    <br>
      <div class="container">
        <div class="col-md-12">
          <div class="row">
            <div class="col-sm divth">
              Username
            </div>
            <div class="col-sm divth">
              Operation
            </div>
            <div class="col-sm divth">
              Gate
            </div>
            <div class="col-sm divth">
              Access Date
            </div>
            <div class="col-sm divth">
              Action(s)
            </div>
          </div>
        </div>

        @for (access of accesslog() | paginate: { itemsPerPage: 50, currentPage: p } | filter:searchUser(); track $index) {
          <div class="col-md-12">
            <div class="row">
              <div class="col-sm divtd">
                {{access.access_by}}
              </div>
              <div class="col-sm divtd">
                {{access.action}}
              </div>
              <div class="col-sm divtd">
                {{access.device_name}}
              </div>
              <div class="col-sm divtd">
                {{access.access_date}}
              </div>
              <div class="col-sm divtd">
                <!-- <button class="btn btn-info">View <fa-icon [icon]="faEye"></fa-icon></button> -->
              </div>
            </div>
          </div>
        }
        <pagination-controls (pageChange)="p = $event"></pagination-controls>
      </div>

    </div>
